
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learning-center/[category]",
      function () {
        return require("private-next-pages/learning-center/[category]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learning-center/[category]"])
      });
    }
  